import { BAYS } from '../../../../../../../constants';
import { TPBayDescription } from '../../../../constants/general';

import type { IRecommendation, Bays } from '../../../../../../../utils/types';

export function getDisplayProvisioningDescription(
  btArray: string[],
  recommendation: IRecommendation | null | undefined,
  tpBay: Bays,
): string {
  if (recommendation?.provision_description) {
    return recommendation.provision_description;
  }

  if (recommendation?.considered_factors && recommendation.considered_factors !== '') {
    return '';
  }

  if (tpBay === BAYS.BAY_2_6 || tpBay === BAYS.BAY_2_5 || tpBay === BAYS.BAY_6) {
    return TPBayDescription[tpBay];
  }

  if (btArray.length === 1) {
    return (
      'This protocol will be administered by ' +
      btArray[0] +
      ', a behavioral therapist, who has gone through the necessary training and additional certifications, where required (e.g., RBT). The behavioral therapist (a) will be employed by (i) the entity contracted with the payor or (ii) an affiliated entity contracted with the payor and (b) is the parent of the recipient. The behavioral therapist will be supervised by a BCBA.'
    );
  } else if (btArray.length > 1) {
    return (
      'This protocol will be administered by ' +
      btArray.join(' or ') +
      ', each a behavioral therapist, who have gone through the necessary training and additional certifications, where required (e.g., RBT). The behavioral therapist (a) will be employed by (i) the entity contracted with the payor or (ii) an affiliated entity contracted with the payor and (b) is the parent of the recipient. The behavioral therapist will be supervised by a BCBA.'
    );
  }

  return '';
}
